/**
 * SCORECARD_PARITY_TESTKIT — React toggle JS vs Python compute.
 */
import React, { useEffect, useState } from "react";
import {
  isParityTestkitEnabled,
  PARITY_SEED,
  readParityComputeSource,
  writeParityComputeSource,
} from "./config";

export default function ScorecardParityToolbar({ source, onSourceChange }) {
  if (!isParityTestkitEnabled()) return null;

  const active = source || "py";

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 8,
        alignItems: "center",
        marginBottom: 12,
        padding: "8px 12px",
        border: "1px dashed #94a3b8",
        borderRadius: 8,
        background: "#f8fafc",
        fontSize: 12,
        color: "#334155",
      }}
    >
      <strong style={{ marginRight: 4 }}>Parity testkit</strong>
      <span>
        (seed {PARITY_SEED})
      </span>
      <div style={{ display: "flex", gap: 6, marginLeft: "auto" }}>
        <button
          type="button"
          onClick={() => onSourceChange("js")}
          style={{
            padding: "4px 10px",
            borderRadius: 6,
            border: active === "js" ? "2px solid #0f172a" : "1px solid #94a3b8",
            background: active === "js" ? "#0f172a" : "#fff",
            color: active === "js" ? "#fff" : "#334155",
            cursor: "pointer",
          }}
          data-testid="main-parity-js-btn">
          JS (client)
        </button>
        <button
          type="button"
          onClick={() => onSourceChange("py")}
          style={{
            padding: "4px 10px",
            borderRadius: 6,
            border: active === "py" ? "2px solid #0f172a" : "1px solid #94a3b8",
            background: active === "py" ? "#0f172a" : "#fff",
            color: active === "py" ? "#fff" : "#334155",
            cursor: "pointer",
          }}
          data-testid="main-parity-py-btn">
          Python API
        </button>
      </div>
    </div>
  );
}

/** Hook for compute source; persists to localStorage. */
export function useParityComputeSource() {
  const [enabled, setEnabled] = useState(isParityTestkitEnabled);
  const [source, setSource] = useState("py");

  const setComputeSource = (next) => {
    const value = next === "py" ? "py" : "js";
    writeParityComputeSource(value);
    setSource(value);
  };

  const computeSource = enabled ? source : "py";

  return {
    parityTestkitEnabled: enabled,
    paritySeed: PARITY_SEED,
    computeSource,
    usePyScorecard: computeSource === "py",
    setComputeSource,
  };
}
